<template>
  <div>
    <div class="mt-5">
      <form-wizard
        error-color="rgb(242, 19, 93)"
        color="rgba(var(--vs-primary), 1)"
        :title="null"
        :subtitle="null"
        finishButtonText="Submit"
        @on-complete="submitDetails"
        @on-error="handleErrorMessage"
      >


        <!-- tab 2 content -->
        <tab-content title="Step 1" class="mb-5" icon="feather icon-info"  :before-change="validOne">
          <p>Key In <b>Driver Information</b> and Proceed.</p>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <vs-input
                label="Full Name"
                v-model="driverInfo.fullName"
                class="w-full mt-4"
              />
                 <vs-input
                 type="date"
                label="Date of Birth"
                v-model="driverInfo.dob"
                class="w-full mt-4"
              />
                  <vs-input
                 type="text"
                label="Mobile No."
                v-model="driverInfo.mobileNumber"
                class="w-full mt-4"
              />
               <vs-input
                 type="text"
                label="IC No."
                v-model="driverInfo.icNumber"
                class="w-full mt-4"
              />
                 <vs-input
                 type="text"
                label="GDL No."
                v-model="driverInfo.gdlNumber"
                class="w-full mt-4"
              />
                   <vs-input
                 type="date"
                label="GDL Expiry Date"
                v-model="driverInfo.gdlExpiry"
                class="w-full mt-4"
              />
                  <vs-input
                 type="text"
                label="Fuel Card No."
                v-model="driverInfo.fuelCard"
                class="w-full mt-4"
              />
                  <vs-input
                 type="text"
                label="Touch N Go Card No."
                v-model="driverInfo.touchNGo"
                class="w-full mt-4"
              />
                    <vs-input
                 type="text"
                label="Radio Set No."
                v-model="driverInfo.radioSetNumber"
                class="w-full mt-4"
              />
                   <vs-input
                 type="text"
                label="Licence No."
                v-model="driverInfo.licenceNumber"
                class="w-full mt-4"
              />
                     <vs-input
                 type="date"
                label="Licence Expiry Date"
                v-model="driverInfo.licenceExpiry"
                class="w-full mt-4"
              />
               <vs-textarea
                v-model="driverInfo.address"
                label="Address"
                class="mb-0 md:mt-10 mt-6"
                rows="3"
              />


             </div>

            <div class="vx-col md:w-1/2 w-full">
                  <vs-input
                 type="text"
                label="Driver App Username"
                v-model="driverInfo.driverUsername"
                class="w-full mt-4"
              />
                <vs-input
                 type="text"
                label="Driver App Password."
                v-model="driverInfo.driverPassword"
                class="w-full mt-4"
              />
              <vs-textarea
                v-model="driverInfo.remarks"
                label="Remarks"
                class="mb-0 md:mt-10 mt-6"
                rows="3"
              />
               <br>
           <label for="myvueDropZone">Upload Recent Images</label>


              <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-success="vehicleImagesUpload"  v-on:vdropzone-removed-file="vehicleImagesRemove"></vue-dropzone>

            </div>
          </div>
        </tab-content>

        <!-- tab 2 content -->
        <tab-content title="Step 2" class="mb-5" icon="feather icon-paperclip" :before-change="validTwo">
          <p>
            Take a moment to <b>Upload Driver Documents</b> for record keeping
            & receive timely notifications.   <br><vs-button color="primary" type="border" icon-pack="feather" icon="icon-layout" @click="addAlarm">Add Document</vs-button>
          </p>

          <table class="responsive">
            <tr>
                <th>No.</th>
            <th>Name</th>
            <th>Expiry [Date]</th>
            <th>Documents</th>
            <th>Remarks</th>
            <th>Actions</th>
            </tr>

              <tr :key="indextr" v-for="(tr, indextr) in driverAlarm">
                    <td>
                        <span> <b>{{indextr+1}}.</b></span>
                    </td>
                    <td>
                  <v-select placeholder="Type" clearable="false" taggable :options="['Driving Licence','GDL','Permits','Passport','Insurance','Make My Own']"  v-model="driverAlarm[indextr].type" />
                    </td>
                    <td>
                      <input
                type="date"
                v-model="driverAlarm[indextr].date"
                class="w-full mt-5"
              />
                    </td>
                    <td>
                      <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-success="driverDocumentsUpload($event,indextr)"  ></vue-dropzone>
                    </td>
                      <td>
                          <vs-textarea
                v-model="driverAlarm[indextr].remark"
                  class="w-full mt-5"
                rows="4"
              />
                    </td>
                    <td>
                      <vs-button color="danger" @click="removeAlarm(indextr)">Remove</vs-button> &nbsp;
                    </td>
                </tr>
          </table>
        </tab-content>

        <!-- tab 4 content -->


        <div class="loader" v-if="loadingWizard"></div>
        <div v-if="errorMsg!=''">
          <span class="error">{{errorMsg}}</span>
        </div>
      </form-wizard>
    </div>
  </div>
</template>

<script>

import {FormWizard, TabContent} from 'vue-form-wizard'
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns'
import { Query, Predicate } from '@syncfusion/ej2-data'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import vSelect from 'vue-select'
import { getBaseURL } from '@/config.js'


export default {
  data () {
    return {
      quickSelect:null,
      userInfo:JSON.parse(localStorage.getItem('userInfo')),
      allowCustomValue:true,
      loadingWizard: false,
      errorMsg: null,
      driverAlarm:[],
      refresh:0,
      unitSelection: JSON.parse(localStorage.getItem('unitSelection')),
      driverInfo:{
        assetId:-1,
        plate:null,
        type:'',
        subType:'',
        brand:'',
        model:'',
        industry:null,
        class:null,
        vehicleImages:[]
      },
      dropzoneOptions: {
        url: getBaseURL() + '/fleets/uploadFiles',
        thumbnailWidth: 150,
        maxFilesize: 10.0,
        maxFiles: 15,
        addRemoveLinks: true
        //autoProcessQueue: false
      }
    }
  },
  watch: {

  },
  methods: {
    contactSupport () {
      window.open(`https://api.whatsapp.com/send?phone=${this.userInfo.help_whatsapp}&text=Hi%20Igeotechgps%20Support!`)
    },
    driverDocumentsUpload (event, index) {
      this.driverAlarm[index].documents.push(JSON.parse(event.xhr.response).path)
      //   console.log(this.driverAlarm);
    },
    removeAlarm (index) {
      this.driverAlarm.splice(index, 1)
    },
    addAlarm () {

      this.driverAlarm.push({type:'', date:'', mileage:'', documents:[], remark:'Amount:- | PIC:- | Payment Status:- | Others:-'})
    },
    handleErrorMessage (errorMsg) {
      this.errorMsg = errorMsg
    },
    vehicleImagesUpload (files, response) {
      this.driverInfo.vehicleImages.push(response.path)
    },

    validOne () {

      return new Promise((resolve, reject) => {

        if (this.driverInfo.fullName == null || this.driverInfo.fullName == '') {

         	reject('Key in Full Name. to continue..')
        }
        if (this.driverInfo.icNumber == null || this.driverInfo.icNumber == '') {

         	reject('Key in Ic Number to continue..')
        }

        if (this.driverInfo.licenceExpiry == null || this.driverInfo.licenceExpiry == '') {

         	reject('Key in Licence Expiry Date to continue..')
        } else {
          resolve(true)
        }

      })
    },
    validTwo () {

      return new Promise((resolve, reject) => {


        if (this.driverInfo.fullName == null || this.driverInfo.fullName == '') {

         	reject('Key in Full Name. to continue..')
        }
        if (this.driverInfo.icNumber == null || this.driverInfo.icNumber == '') {

         	reject('Key in Ic Number to continue..')
        }


        if (this.driverAlarm.length == 0) {

         	reject('Add at least 1 document to continue..')
        } else {
          resolve(true)
        }

      })
    },

    formSubmitted () {
      alert('Form submitted!')
    },
    submitDetails () {
      const self = this

      self.$http.post('drivers/submit', {
        userInfo:self.userInfo,
        driverInfo:self.driverInfo,
        driverAlarm:self.driverAlarm
      })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.$emit('exit', true)
            return  self.$vs.notify({
              title: 'New record added',
              text: 'Driver info added!',
              iconPack: 'feather',
              icon: 'icon-refresh-cw',
              color: 'success'
            })

          } else {
            self.$emit('exit', true)
            if (response.data.error) {

              return  self.$vs.notify({
                title: 'Error',
                text: response.data.error,
                iconPack: 'feather',
                icon: 'icon-refresh-cw',
                color: 'warning'
              })
            } else {

              return  self.$vs.notify({
                title: 'Error',
                text: 'Could not created FMS Driver record at this time.Try again later.',
                iconPack: 'feather',
                icon: 'icon-refresh-cw',
                color: 'warning'
              })
            }
          }
        })
        .catch(function (error) {
          self.$emit('exit', true)
        })
    }
  },
  mounted () {

  },
  components: {
    FormWizard,
    TabContent,
    MultiSelectPlugin,
    Query,
    Predicate,
    vueDropzone: vue2Dropzone,
    vSelect
  }
}
</script>

<style scoped>
@import "../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-buttons/styles/material.css";

.e-multiselect {
  border-bottom: 1px solid #ffffff;
  font-family: "Montserrat";
}
.e-multi-select-wrapper {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  font-family: "Montserrat";
  height: 40px;
}

.e-multi-select-wrapper-e-delimiter {
  font-family: "Montserrat";
}
.error {
  color:'red';
  font-weight:'bold';
  font-size:'20px'

}
.vs-table {
overflow-y: visible !important;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}


</style>
